<template>
  <div>
        <!-- -->
        <div v-if="!inline">
        <el-empty description="No Data" v-if="getCustomerTempMeasurementList.profile_list.length === 0">
            <el-button @click="addNewMeasurement" size="small">Add New {{item_category_name}} Measurement</el-button>
        </el-empty>

        <div v-else>
            <el-table
                border
                :data="getCustomerTempMeasurementList.profile_list"
                style="width: 100%">
                <el-table-column 
                prop="registration_date"
                label="Registration Date">
                    <template slot-scope="scope">
                        <el-date-picker
                            v-if="scope.row.id === 0"
                            size="small"
                            disabled
                            v-model="scope.row.registration_date"
                            type="date"
                            value-format="yyyy-MM-dd"
                            format="MMM dd yyyy">
                        </el-date-picker>
                        <div v-else>
                            {{scope.row.registration_date_formatted}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column 
                    prop="measurement_field_list"
                    label="Values" align="center" width="100">            
                    <template slot-scope="scope">
                        <el-button @click="openMeasurementListPopup(scope.row.key)" size="small" icon="el-icon-s-grid"></el-button>
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="" width="70">
                    <template slot-scope="scope">
                        <div style="text-align: right; display: flex; flex-direction: row; justify-content: flex-end; align-items: flex-end;">
                            <el-tooltip class="item" effect="dark" content="Add">
                                <a 
                                    v-if="(scope.row.id>0 && scope.row.key === 0)" 
                                    @click="$store.commit('addNewCustomerMasterMeasurementProfileListRow', getCurrentItemCategoryId)" 
                                    style="cursor: pointer; font-size: 24px;">
                                        <i class="el-icon-circle-plus"></i>
                                </a>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="Delete">
                                
                                <el-popconfirm
                                    @confirm="removeList(scope.row.key)"
                                    title="Are you sure to delete this?"
                                    >
                                    <a slot="reference" style="cursor: pointer; margin-left: 10px; color: red; font-size: 16px;">
                                        <i class="el-icon-delete"></i>
                                    </a>
                                    
                                </el-popconfirm>
                            </el-tooltip>
                            
                        </div>                                        
                    </template>
                </el-table-column>
                </el-table>
        <!-- -->
            <el-dialog
                :visible.sync="msmt_list_visible"
                :show-close="false"
                append-to-body	
                width="90%">
                <div style="top: -30px; position: relative; width: 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between;">
                    <h2 style="top: -25px; position: relative;">{{item_category_name+' Measurement'}}</h2>
                    <div style="text-align: right;">
                        <el-button v-if="getCustomerTempMeasurementList.profile_list[getMsmtProfileKey] !== undefined && getCustomerTempMeasurementList.profile_list[getMsmtProfileKey].id === 0" @click="submitMeasurement" size="small" type="primary" style="width: 100px; height: 30px;">
                            Submit
                        </el-button>
                        
                        <el-button @click="msmt_list_visible = false" size="small" type="danger" style="width: 100px; height: 30px;">
                            Close
                        </el-button>
                    </div>
                </div>
                <div style="top: -50px; position: relative;">
                    
                    <MeasurementFieldList 
                        v-if="getMsmtProfileKey>=0 && getCustomerTempMeasurementList.profile_list[getMsmtProfileKey] !== undefined"
                        :item_category_id="item_category_id"
                        :profile_data="getCustomerTempMeasurementList.profile_list[getMsmtProfileKey]"
                        :profile_id="getCustomerTempMeasurementList.profile_list[getMsmtProfileKey].id"
                        :measurement_list="getCustomerTempMeasurementList.profile_list[getMsmtProfileKey].measurement_field_list"/>
                </div>
                
            </el-dialog>
        </div>
        </div>
        <div v-else>
            <MeasurementFieldList 
                
                :inline="inline"
                :msmt_form="msmt_form"
                :profile_data="customer_measurement_profile"/>
        </div>
        
  </div>
</template>

<script>
import MeasurementFieldList from './MeasurementFieldList.vue'

export default {
    components: {MeasurementFieldList},
    props: ['msmt_form', 'item_category_id', 'item_category_name', 'master_measurement_list', 'inline', 'customer_measurement_profile'],
    data() {
        return {
            msmt_profile_key: -1,
            msmt_list_visible: false
        }
    },
    computed: {
        getMsmtProfileKey() {
            return this.msmt_profile_key
        },
        getCurrentItemCategoryId() {
            return this.item_category_id
        },
        getCustomerTempMeasurementList() {            
            return this.$store.state.customerMaster.props.temp_measurement_profile_list[this.getTailoringCategoryIndex]
        },
        getTailoringCategoryIndex() {
            return this.$store.state.customerMaster.props.temp_measurement_profile_list.findIndex((element) => {
                return element.tailoring_category_id === this.getCurrentItemCategoryId
            })
        }
    },
    methods: {
        submitMeasurement() {
            this.msmt_list_visible = false
            let payload = JSON.parse(JSON.stringify(this.$store.getters.getCustomerMasterDataProps))
            if(payload.salutation_id === null || payload.salutation_id === 0) {
                this.$store.commit('displayMessageAlert', {message: 'Please select a salutation of the customer', type: 'Error'})    
                document.getElementById('salutation_id').focus()
                return
            } else if(payload.type_of_customer === 1 && payload.company_name.length === 0) {
                this.$store.commit('displayMessageAlert', {message: 'Please enter name of the business entity', type: 'Error'})    
                document.getElementById('company_name').focus()
                return
            } else if(payload.customer_name.length === 0) {
                this.$store.commit('displayMessageAlert', {message: 'Please enter name of the customer', type: 'Error'})    
                document.getElementById('customer_name').focus()
                return
            } else if(payload.customer_name.length === 0) {
                this.$store.commit('displayMessageAlert', {message: 'Please enter name of the customer', type: 'Error'})    
                document.getElementById('customer_name').focus()
                return
            } else if(payload.primary_mobile_number_calling_code === null 
                || payload.primary_mobile_number_calling_code === 0) {
                this.$store.commit('displayMessageAlert', {message: 'Please provide a valid country code for primary mobile number', type: 'Error'})    
                document.getElementById('primary_mobile_number_calling_code').focus()
                return
            } else if(payload.primary_mobile_number.length < 5) {
                this.$store.commit('displayMessageAlert', {message: 'Please provide a valid primary mobile number', type: 'Error'})    
                document.getElementById('primary_mobile_number').focus()
                return
            } else if(this.$store.getters.getPreferenceProps.email_address_required_in_customer_form 
                        && payload.email_address.length === 0) {
                this.$store.commit('displayMessageAlert', {message: 'Please provide a valid email address', type: 'Error'})    
                document.getElementById('email_address').focus()
                return
            } else if(this.$store.getters.getPreferenceProps.email_address_required_in_customer_form 
                        && payload.email_address.length > 0 
                            && this.invalidEmailAddress(payload.email_address)) {
                this.$store.commit('displayMessageAlert', {message: 'Please provide a valid email address', type: 'Error'})    
                document.getElementById('email_address').focus()
                return
            } else if(this.$store.getters.getPreferenceProps.customer_address_required_in_customer_form 
                        && (payload.address.length === 0 
                                || payload.country_id === null || payload.country_id === 0
                                    || payload.province_id === null || payload.province_id === 0
                                        || payload.city_id === null || payload.city_id === 0)) {
                this.$store.commit('displayMessageAlert', {message: 'Please provide a valid address', type: 'Error'})    
                return
            } else if(this.$store.getters.isIndiaTax 
                    && payload.tax_registration_number !== null && payload.tax_registration_number.length >3 
                        && (payload.province_id === null || payload.province_id === 0)) {
                this.$store.commit('displayMessageAlert', {message: 'Please select a valid state or province code for GST calculation.', type: 'Error'})    
                document.getElementById('country_id').focus()
                return
            }
            
            this.$store.dispatch('submitCustomerMasterData', payload)
        },
        addNewMeasurement() {
            this.$store.commit('addNewCustomerMasterMeasurementProfileListRow', this.getCurrentItemCategoryId)

            if(this.inline) {
                this.openMeasurementListPopup(this.getCustomerTempMeasurementList.profile_list.length-1)
            }
        },
        openMeasurementListPopup(key) {

            let masterMeasurementList = this.$store.getters.getMeasurementTemplateList.filter(element => {
                return element.category_id === this.getCurrentItemCategoryId
            })
            
            if(masterMeasurementList.length > 0) {
                
                let msmt_master_list = JSON.parse(JSON.stringify(masterMeasurementList[0].measurement_list))
                    
                let msmt_field_list = this.getCustomerTempMeasurementList.profile_list[key].measurement_field_list

                if(msmt_field_list.length === 0) {
                    
                    msmt_master_list.forEach(element => {
                        element.measurement_id = element.id
                        
                        let msmtFieldIndex = -1
                        if(this.getCustomerTempMeasurementList.profile_list[0] !== undefined) {
                            msmtFieldIndex = this.getCustomerTempMeasurementList.profile_list[0].measurement_field_list.findIndex(t => t.measurement_id === element.measurement_id)                        
                        }

                        if(msmtFieldIndex>=0) {
                            element.measurement_value = this.getCustomerTempMeasurementList.profile_list[0].measurement_field_list[msmtFieldIndex].measurement_value
                        } else {
                            element.measurement_value = ''
                        }            
            
                    })
                    this.$store.state.customerMaster.props
                        .temp_measurement_profile_list[this.getTailoringCategoryIndex]
                            .profile_list[key].measurement_field_list = msmt_master_list

                } else {
                    
                    msmt_master_list.forEach(masterElement => {
                        msmt_field_list.forEach(element => {
                            if(masterElement.id === element.measurement_id) {
                                element.measurement_value_fixed = masterElement.measurement_value_fixed
                                element.measurement_instruction_image = masterElement.measurement_instruction_image
                                element.measurement_drop_down_list = masterElement.measurement_drop_down_list
                                element.measurement_name = masterElement.measurement_name                                
                            } else {
                                element = JSON.parse(JSON.stringify(masterElement))
                                element.measurement_id = element.id
                                element.measurement_value = ''
                            }
                        })
                    })
                    
                }
                this.msmt_profile_key = key
                this.msmt_list_visible = true
            } else {
                this.$store.commit('displayMessageAlert', {message: 'Error, please contact your administrator or email us.', type: 'Error'})    
                
            }
        },
        removeList(key) {
            this.msmt_profile_key = -1
            this.$store.commit('removeCustomerMasterMeasurementProfileListRow', {key: key, tailoring_category_id: this.getCurrentItemCategoryId})
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/CustomerMaster/Form/MeasurementProfile/ProfileList.vue